'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Component } from 'react';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import ProgressBar from './ProgressBar';
import Score from './Score';
import UIUtil from '../util/UIUtil';

var BreakdownScore = /*#__PURE__*/function (_Component) {
  _inherits(BreakdownScore, _Component);

  function BreakdownScore() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, BreakdownScore);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(BreakdownScore)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.titleClicked = function () {
      UIUtil.scrollTo("#" + _this.props.page);
    };

    return _this;
  }

  _createClass(BreakdownScore, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          score = _this$props.score,
          overallScore = _this$props.overallScore,
          page = _this$props.page;
      var scorePercentage = score / overallScore * 100;
      return /*#__PURE__*/_jsxs(Score, {
        scorePercentage: scorePercentage,
        onClick: this.titleClicked,
        children: [/*#__PURE__*/_jsxs("div", {
          className: "score-title",
          children: [/*#__PURE__*/_jsx("div", {
            className: "auditTitle",
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "results." + page + ".title"
            })
          }), /*#__PURE__*/_jsxs("div", {
            className: "score",
            children: [score, /*#__PURE__*/_jsxs("span", {
              className: "overall",
              children: ["/", overallScore]
            })]
          })]
        }), /*#__PURE__*/_jsx(ProgressBar, {
          scorePercentage: scorePercentage
        })]
      });
    }
  }]);

  return BreakdownScore;
}(Component);

BreakdownScore.propTypes = {
  page: PropTypes.string.isRequired,
  score: PropTypes.number.isRequired,
  overallScore: PropTypes.number.isRequired
};
export { BreakdownScore as default };